import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  textWidth: {
    minWidth: 118,
  },
}));

export default useStyles;
